import { AxiosRequestConfig } from 'axios'

import { CreateStorePayload, UpdateStoreData, UpsertPartnerStorePayload } from './types'

const getStores = (): AxiosRequestConfig => ({
  url: '/stores',
  method: 'GET',
})

const createStore = (payload: CreateStorePayload): AxiosRequestConfig => ({
  url: '/stores',
  method: 'POST',
  data: { store: payload },
})

const updateStore = (data: UpdateStoreData): AxiosRequestConfig => ({
  url: `/stores/${data.id}`,
  method: 'PUT',
  data: { store: data.payload },
})

const deleteStore = (id: number): AxiosRequestConfig => ({
  url: `/stores/${id}`,
  method: 'DELETE',
})

const checkAnalystHasAllStores = (): AxiosRequestConfig => ({
  url: '/stores/analyst-has-all-stores',
  method: 'GET',
})

const getExternalApiPartners = (): AxiosRequestConfig => ({
  url: '/external-api/partners',
  method: 'GET',
})

const getStorePartnerStores = (storeId: number): AxiosRequestConfig => ({
  url: `/stores/${storeId}/partner-stores`,
  method: 'GET',
})

const upsertStorePartnerStore = (
  storeId: number,
  partnerStore: UpsertPartnerStorePayload,
): AxiosRequestConfig => ({
  url: `/stores/${storeId}/partner-stores`,
  method: 'POST',
  data: { partnerStore },
})

export {
  getStores,
  createStore,
  updateStore,
  deleteStore,
  checkAnalystHasAllStores,
  getExternalApiPartners,
  getStorePartnerStores,
  upsertStorePartnerStore,
}
